
define(
	'Code25.CaterpartsGlobal.Login'
	, [
		"underscore", "jQuery"
	]
	, function (
		_, jQuery
	) {
		'use strict';

		return {
            mount: function (container) {

                var LiveOrderModel = require('LiveOrder.Model');

				window.setInterval(function () {

					try {
						var model = LiveOrderModel.getInstance();

						model.fetch();
						console.log("Stay logged in.");
					} catch (err) {

					}
				}, 1000 * 60 * 5);
					

            }
        };

	});
